import * as THREE from "three";
import Proton from "three.proton.js";

export default class ThreeFX {

    static async preload(){
        this.leavesTexture = new THREE.TextureLoader().load( "src/assets/particles/leaves/leaves_3.png" );
        this.dotTexture = new THREE.TextureLoader().load( "src/assets/particles/dot/dot.png" );
    }

    static init(game) {
        this.proton = new Proton();
        this.game = game;
        this.scene = this.game.threeScene;
        this.proton.addRender(new Proton.SpriteRender(this.scene));
        this.emitLeaves();
        this.createSparksEmitter()
    }

    static renderDebug(){
        Proton.Debug.renderInfo(this.proton, 4);
    }

    static createSprite(texture, blending = THREE.NormalBlending) {
        const material = new THREE.SpriteMaterial({
            map: texture,
            color: 0x549B8C,
            blending
        });
        return new THREE.Sprite(material);
    }

    static emitLeaves(){
        var emitter = new Proton.Emitter();

        //setRate
        emitter.rate = new Proton.Rate(new Proton.Span(1, 2), new Proton.Span(.04));

        emitter.addInitialize(new Proton.Body(this.createSprite(this.leavesTexture)))

        //addInitialize
        emitter.addInitialize(new Proton.Position(new Proton.BoxZone(0, 5, 10, 10, 10, 10)));
        emitter.addInitialize(new Proton.Mass(1));
        emitter.addInitialize(new Proton.Life(3));
        emitter.addInitialize(new Proton.V(15, new Proton.Vector3D(0, -2, -50), 1));

        //addBehaviour
        emitter.addBehaviour(new Proton.Color('random', 'random', Infinity, Proton.easeOutQuart));
        emitter.addBehaviour(new Proton.Scale(0.1, 0.3));
        emitter.addBehaviour(new Proton.RandomDrift(.2, 0, 0,));
        emitter.addBehaviour(new Proton.Rotate(Proton.createSpan(-1,1),Proton.createSpan(-1,1),Proton.createSpan(-1,1)));
        emitter.emit();

        //add emitter
        this.proton.addEmitter(emitter);

        //add renderer

    }

    static emitTail(x, y, color1, color2){
        var emitter = new Proton.Emitter();
        emitter.rate = new Proton.Rate(new Proton.Span(5, 7), new Proton.Span(.05, .01));
        emitter.addInitialize(new Proton.Mass(1));
        emitter.addInitialize(new Proton.Life(.5));
        emitter.addInitialize(new Proton.Body(this.createSprite(this.dotTexture, THREE.AdditiveBlending)));
        emitter.addInitialize(new Proton.Radius(Proton.Span(.1,.2)));
        emitter.addInitialize(new Proton.V(1, new Proton.Vector3D(0, 0, -1), 0));

        emitter.addBehaviour(new Proton.Alpha(1, 0));
        emitter.addBehaviour(new Proton.Color(color1, color2));
        emitter.addBehaviour(new Proton.Scale(1, .5));
        emitter.addBehaviour(new Proton.CrossZone(
            new Proton.ScreenZone(this.game.threeCamera, this.game.threeRenderer), 'dead')
        );


        emitter.addBehaviour(new Proton.Force(0, 0, -.2));

        // emitter.addBehaviour(new Proton.Attraction({
        //     x: 0,
        //     y: 0,
        //     z: 0
        // }, 5, 250));



        emitter.p.x = x;
        emitter.p.y = y;
        emitter.p.z = 0;
        emitter.emit();

        this.proton.addEmitter(emitter);
        return emitter;
    }

    static createSparksEmitter(){
        this.sparksEmitter = new Proton.Emitter();
        this.sparksEmitter.rate = new Proton.Rate(new Proton.Span(20, 30), 0.01);
        this.sparksEmitter.addInitialize(new Proton.Body(this.createSprite(this.dotTexture, THREE.AdditiveBlending)));
        this.sparksEmitter.addInitialize(new Proton.Mass(.1));
        this.sparksEmitter.addInitialize(new Proton.Life(1.15, 1.3));
        this.sparksEmitter.addInitialize(new Proton.Position(new Proton.SphereZone(1.25)));
        this.sparksEmitter.addInitialize(new Proton.V(5, new Proton.Vector3D(0, 0, -1), 0));

        this.sparksEmitter.addBehaviour(new Proton.RandomDrift(1.5, 1.5, .5));
        //this.sparksEmitter.addBehaviour(new Proton.Alpha(1, 0.1));
        this.sparksEmitter.addBehaviour(new Proton.Scale(new Proton.Span(.25, .5), 0));
        this.sparksEmitter.addBehaviour(new Proton.Color('#FF0026', ['#ffff00', '#ffff11'], Infinity, Proton.easeOutSine));
        this.proton.addEmitter(this.sparksEmitter);

        this.sparksEmitter.p.x = 0;
        this.sparksEmitter.p.y = 0;
        this.sparksEmitter.p.z = 0;
    }
    
    static emitSparks(position){
        this.sparksEmitter.p.x = position.x;
        this.sparksEmitter.p.y = position.y;
        this.sparksEmitter.p.z = position.z;

        this.sparksEmitter.emit(.05);
    }
}